import React, { Component } from 'react';
import {
  Text, View, StyleSheet, Image, ScrollView, Platform,
} from 'react-native';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { toggleDieticianModal } from '../../ui';
import { UserDataConsumer } from '../../utils';
import { getUrls } from '../../config';
import Theme from '../../theme';
import { Button } from '../../components';
import { defaultScale } from '../../utils/scaling';
import { openLink } from '../../utils/linkUtils';

export class DieticianNutritionSource extends Component {
  static propTypes = {
    prop: PropTypes,
  };

  openSportsDietitians = () => {
    openLink('https://www.sportsdietitians.com.au/');
  };

  openSportsDietitiansWeightLoss = () => {
    openLink('https://www.sportsdietitians.com.au/factsheets/body-composition/weight-loss-body-fat-athletes/');
  };

  openSportsDietitiansMuscleMass = () => {
    openLink('https://www.sportsdietitians.com.au/factsheets/body-composition/increasing-muscle-mass/');
  };

  closeDieticianModal = () => {
    this.props.toggleDieticianModal(false);
  };

  openNutritionSource = () => {
    const { NUTRITION_SCIENCE } = getUrls();
    openLink(NUTRITION_SCIENCE);
  };

  render() {
    const {
      t,
      isLoading,
    } = this.props;

    return (
      <View style={styles.container}>
        <ScrollView>
          <Image
            resizeMode='contain'
            style={styles.nutritionLogo}
            source={require('../../assets/images/icon-nutrition-b@500px.png')}
          />
          <Text style={styles.header}>{t('nutritionScience')}</Text>
          <View style={styles.lineSeparator} />
          <View style={styles.nutritionSourceContainer}>
            <Text>
              <Text style={styles.nutritionSource}>{t('nutritionSource')}</Text>
              <Text
                onPress={this.openSportsDietitians}
                style={[styles.nutritionSourceLink, styles.nutritionSourceDesc]}
              >
                {t('nutritionalLink')}
              </Text>
            </Text>
            <Text style={[styles.nutritionSource]}>{t('specifically')}</Text>
            <Text onPress={this.openSportsDietitiansWeightLoss} style={styles.nutritionSource}>
              <Text>
                -
                {t('weightLossProgram')}
              </Text>
              <Text style={styles.nutritionSourceLink}>
                {' '}
                {t('weightLostFatAthletes')}
              </Text>
            </Text>
            <Text onPress={this.openSportsDietitiansMuscleMass} style={styles.nutritionSource}>
              <Text>
                -
                {t('buildMuscleProgram')}
              </Text>
              <Text style={styles.nutritionSourceLink}>
                {' '}
                {t('increasingMuscleMass')}
              </Text>
            </Text>
            <Text onPress={this.openNutritionSource} style={styles.nutritionSource}>
              <Text>
                -
                {t('nutritionDesscription3')}
              </Text>
              <Text style={styles.nutritionSourceLink}>
                {' '}
                {t('here')}
                .
              </Text>
            </Text>
          </View>
        </ScrollView>
        <View style={styles.footer}>
          <Button
            fontColor={Theme.WHITE}
            isLoading={isLoading}
            title={t('close')}
            onPress={this.closeDieticianModal}
          />
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    marginVertical: defaultScale(10),
    flex: 1,
    ...Platform.select({
      web: {
        height: '100vh',
      },
    }),
  },
  header: {
    ...Theme.textStyle.heading,
    alignSelf: 'center',
    color: '#424242',
    marginBottom: defaultScale(10),
    textAlign: 'center',
  },
  lineSeparator: {
    height: defaultScale(2),
    marginTop: defaultScale(5),
    backgroundColor: Theme.GREY_LIGHT,
  },
  nutritionLogo: {
    alignSelf: 'center',
    width: defaultScale(40),
    height: defaultScale(40),
    margin: defaultScale(2.5),
    marginHorizontal: defaultScale(10),
  },
  fitnessGoalHeader: {
    flexDirection: 'row',
    alignContent: 'center',
    justifyContent: 'center',
    marginVertical: defaultScale(15),
  },
  fitnessHeader: {
    ...Theme.textStyle.heading,
    color: Theme.DARK_CHARCOAL,
    alignSelf: 'center',
  },
  nutritionSourceDesc: {
    paddingBottom: defaultScale(10),
  },
  nutritionSourceContainer: {
    paddingVertical: defaultScale(15),
  },
  nutritionSource: {
    ...Theme.textStyle.small,
    color: '#4C4C4C',
    alignSelf: 'flex-start',
    flexWrap: 'wrap',
    textAlign: 'left',
    paddingVertical: defaultScale(10),
  },
  nutritionSourceLink: {
    ...Theme.textStyle.small,
    color: Theme.PRIMARY,
  },
  footer: {
    flex: 1,
    alignContent: 'flex-end',
    justifyContent: 'flex-end',
  },
});

const mapDispatchToProps = (dispatch) => ({
  toggleDieticianModal: (value) => dispatch(toggleDieticianModal(value)),
});

DieticianNutritionSource = UserDataConsumer(DieticianNutritionSource);
DieticianNutritionSource = connect(null, mapDispatchToProps)(DieticianNutritionSource);
export default translate(['nutrition'], { wait: true })(DieticianNutritionSource);
